import { render, staticRenderFns } from "./ChatOrderSum.vue?vue&type=template&id=2bbfa73a&scoped=true&"
import script from "./ChatOrderSum.vue?vue&type=script&lang=js&"
export * from "./ChatOrderSum.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderSum.vue?vue&type=style&index=0&id=2bbfa73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfa73a",
  null
  
)

export default component.exports